export default __webpack_public_path__ + "static/media/delete.6dcadd95.svg";